import { ethers } from "ethers";
import React, { Component } from "react";
import getContract from "../../services/contract";
import { Link } from 'react-router-dom';
import transactionTypes from '../../helpers/transactionType';
import withWrapper from '../../helpers/withWrapper';

class Matrix extends Component {
  state = {
    idsWithLevel: new Array(7).fill(0),
    childrenTransactionTypes: [],
    previewCycle: 0
  };
  constructor(props) {
    super(props);
    this.state.userId = props.router.params.id;
    this.state.level = props.router.params.level;
    this.state.reinvestNo = 0;
  }

  handleIdClick = async (userId) => {
    await this.setData(userId);
    this.props.router.navigate('/dashboard/' + userId + '/' + this.state.level);
  }

  handleReinvestClick = async (userId, cycleId) => {
    await this.setData(userId, cycleId);
  }

  async componentDidMount() {


    await this.setData(this.state.userId);
  }

  setData = async (userId, cycleNumber) => {
    const contract = await getContract();
    const userAddress = await contract.getAddressById(userId);

    const latestReinvest = ethers.BigNumber.from(await contract.userReInvestNumbers(userId, this.state.level)).toNumber();

    let reinvestNo = latestReinvest;
    if (cycleNumber != undefined) {
      reinvestNo = +cycleNumber;
    }
    

    if(cycleNumber == undefined && userId == 1) {
      reinvestNo = 0;
    }

    const activeGoldInfoResponse = await contract.userMatrixInfo(userId, this.state.level, reinvestNo);
    const currentParrent = ethers.BigNumber.from(activeGoldInfoResponse["currentParent"]).toNumber();

    const transactionTypsesResponse = await contract.getChildrenTreeInfo(userId, this.state.level, reinvestNo);
    let transactions = [];

    transactionTypsesResponse.forEach((t, index) => {
      const transaction = { userId: ethers.BigNumber.from(t["userId"]).toNumber(), type: t["transactionType"], index: index + 1 }
      transaction.typeProperties = transactionTypes[transaction.type];
      transactions.push(transaction);
    })

    const idsResponse = await contract.getTree(userId, this.state.level, reinvestNo);
  
    const userWithLevel = [];
    idsResponse.forEach((response, index) => {
      
      const id = ethers.BigNumber.from(response).toNumber();
      userWithLevel[index] = id;
    });

    console.log(cycleNumber);
    this.setState({
      idsWithLevel: userWithLevel, reinvestNo: latestReinvest, previewCycle: reinvestNo,
      userAddress, userId, childrenTransactionTypes: transactions, currentParrent
    });
  }

  copyToClipboard = (value) => {

  }

  handleGlobalRewardsClick = async () => {
    this.props.router.navigate('/global-rewards/' + this.state.userId + '/' + this.state.level);
  }

  getClass = (id) => {
    const idIndex = this.state.idsWithLevel.indexOf(id);
    console.log(idIndex);

    // const transactions = this.state.childrenTransactionTypes.filter(t => t.userId == id && t.index == idIndex);
    // if(transactions.length > 1) {

    // }
    const txType = this.state.childrenTransactionTypes.find(t => t.userId == id);
    return (txType) ? txType.typeProperties.class : "bg-yellow";
  }

  render() {
    return (
      <div className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14">
        <div className="flex relative flex-1 py-2 pt-8.5 flex-col justify-between w-full px-10 sm:px-0 sm:pt-7.5">
          <div className="flex flex-col space-y-10 sm:space-y-7.5 z-0">
            <div className="flex z-10 !mt-0">
              <div className="flex flex-col w-full flex-wrap sm:px-5">
                <div className="flex items-center mb-1.5 sm:mb-2.5">
                  <div className="flex">
                    <a
                      className="mr-1.5 text text-white-300 sm:text-sm"
                      href="#"
                    >
                      <span className="hover:text-white-500">UDT</span> /
                    </a>
                  </div>
                  <span className="text text-white whitespace-nowrap sm:text-sm">
                    UDT {this.state.level}
                  </span>
                </div>
                <div className="w-full flex justify-between flex-wrap">
                  <div className="flex items-center">
                    <span className="text-two-half text-white font-medium mr-2 sm:text-2xl whitespace-nowrap">
                      UDT {this.state.level}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            
            <a
              className="flex w-full items-center justify-center sm:px-5 z-10"
            >
              <button onClick={() => this.handleIdClick(this.state.currentParrent)} className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-2.5 bg-black-light hover:bg-line-gray active:bg-active-gray !p-5 w-8/12 xl:w-full sm:!p-4 rounded font-normal">
                <span className="text-white text-base !leading-30px sm:text-sm">
                  Upline
                </span>
                <span className="rounded bg-white-100 px-2.5 text-white text-base ml-2.5 !leading-30px sm:text-sm">
                  ID {this.state.currentParrent}
                </span>
              </button>
            </a>
            <div className="">
              <div className="flex flex-col sm:px-5 space-y-10 z-10">
                <div
                  className="flex space-x-10 xl:space-x-0 z-10">
                  {(this.state.level > 1) && (
                    <button className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-2.5 bg-black-light hover:bg-line-gray active:bg-active-gray min-w-140px xl:hidden p-7 bg-black-light rounded">
                      <a
                        className="flex items-center justify-center font-normal h-full w-full"
                        href={`/dashboard/${this.state.userId}/${+this.state.level - 1}`}
                      >
                        <span className="text-white text-base mr-2.5">
                          Round {this.state.level - 1}
                        </span>

                      </a>
                    </button>
                  )}

                  <div className="flex w-full min-h-340px sm:min-h-290px col-span-4 rounded relative  efcard hover:bg-gray-800">
                    <div className="flex w-full flex-col z-10 p-7.5 sm:p-5">
                      <div className="flex w-full justify-between mb-7.5 z-10">
                        <div className="flex flex-1 items-start justify-start ">
                          {/* <div className="flex items-center space-x-2.5">
                            <span className="text-white-300 text-two-half font-normal sm:text-xl">
                              {this.state.reinvestNo}
                            </span>
                          </div> */}
                        </div>
                        <div className="flex-1 flex flex-col items-center">
                          <span className="text-white text-two-half font-medium mb-2.5 sm:text-xl">
                            ID {this.state.userId}
                          </span>
                        </div>
                        <div className="flex items-start justify-end flex-1 text-white-300 text-two-half font-normal text-right  sm:text-xl"></div>
                      </div>
                      <div className="flex flex-col w-full h-full z-10">
                        <div className="flex justify-center mb-5 sm:mb-10">
                          <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                            <div className="flex flex-col justify-around items-center w-full">
                              <a onClick={() => this.handleIdClick(this.state.idsWithLevel[1])}>
                                <div className="relative">
                                  {(!this.state.idsWithLevel[1]) ?
                                    <div className="flex flex-col rounded-full bg-white-100 w-20 h-20 sm:w-15 sm:h-15 items-center justify-center text-white-100 group hover:opacity-75">
                                      <img
                                        src="/logo/favicon.ico"
                                        className="w-6 h-6 sm:h-4 sm:w-4 false"
                                      />
                                    </div> :
                                    <div className={"flex flex-col rounded-full w-20 h-20 sm:w-15 sm:h-15 items-center justify-center text-white-100 group hover:opacity-75 "
                                      + this.getClass(this.state.idsWithLevel[1])}>
                                      <span className="text-black text-base sm:text-sm">{this.state.idsWithLevel[1]}</span>
                                    </div>
                                  }
                                </div>
                              </a>
                              <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                <div className="flex flex-col justify-around items-center w-full">
                                  <a onClick={() => this.handleIdClick(this.state.idsWithLevel[3])}>
                                    <div className="relative">
                                      {(!this.state.idsWithLevel[3]) ?
                                        <div className="flex flex-col rounded-full bg-white-100 w-20 h-20 sm:w-10 sm:h-10 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                          <img
                                            src="/logo/favicon.ico"
                                            className="w-6 h-6 sm:h-4 sm:w-4 false"
                                          />
                                        </div> :
                                        <div className={"flex flex-col rounded-full w-20 h-20 sm:w-10 sm:h-10 items-center justify-center text-main-blue text-base group hover:opacity-75 "
                                          + this.getClass(this.state.idsWithLevel[3])}>
                                          <span className="text-black text-base sm:text-sm">{this.state.idsWithLevel[3]}</span>
                                        </div>
                                      }

                                    </div>
                                  </a>
                                  <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                    <div className="flex flex-col justify-around items-center w-full">
                                      <a onClick={() => this.handleIdClick(this.state.idsWithLevel[7])}>
                                        <div className="relative">
                                          {(!this.state.idsWithLevel[7]) ?
                                            <div className="flex flex-col rounded-full bg-white-100 w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                              <img
                                                src="/logo/favicon.ico"
                                                className="w-6 h-6 sm:h-4 sm:w-4 false"
                                              />
                                            </div> :
                                            <div className={"flex flex-col rounded-full w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75 "
                                              + this.getClass(this.state.idsWithLevel[7])}>
                                              <span className="text-black text-base sm:text-sm">{this.state.idsWithLevel[7]}</span>
                                            </div>
                                          }
                                        </div>
                                      </a>
                                      <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                        <div className="flex flex-col justify-around items-center false">
                                          <a onClick={() => this.handleIdClick(this.state.idsWithLevel[15])}>
                                            <div className="relative">
                                              {(!this.state.idsWithLevel[15]) ?
                                                <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                  <img
                                                    src="/logo/favicon.ico"
                                                    className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                  />
                                                </div> :
                                                <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false "
                                                  + this.getClass(this.state.idsWithLevel[15])}>
                                                  <span className="matrix-details-id text-black text-base sm:text-sm">{this.state.idsWithLevel[15]}</span>
                                                </div>
                                              }
                                            </div>
                                          </a>
                                        </div>
                                        <div className="flex flex-col justify-around items-center false">
                                          <a onClick={() => this.handleIdClick(this.state.idsWithLevel[16])}>
                                            <div className="relative">
                                              {(!this.state.idsWithLevel[16]) ?
                                                <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                  <img
                                                    src="/logo/favicon.ico"
                                                    className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                  />
                                                </div> :
                                                <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false "
                                                  + this.getClass(this.state.idsWithLevel[16])} >
                                                  <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.idsWithLevel[16]}</span>
                                                </div>
                                              }
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex flex-col justify-around items-center w-full">
                                      <a onClick={() => this.handleIdClick(this.state.idsWithLevel[8])}>
                                        <div className="relative">
                                          {(!this.state.idsWithLevel[8]) ?
                                            <div className="flex flex-col rounded-full bg-white-100 w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                              <img
                                                src="/logo/favicon.ico"
                                                className="w-6 h-6 sm:h-4 sm:w-4 false"
                                              />
                                            </div> :
                                            <div className={"flex flex-col rounded-full w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75 "
                                              + this.getClass(this.state.idsWithLevel[8])}>
                                              <span className="text-black text-base sm:text-sm">{this.state.idsWithLevel[8]}</span>
                                            </div>
                                          }
                                        </div>
                                      </a>
                                      <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                        <div className="flex flex-col justify-around items-center false">
                                          <a onClick={() => this.handleIdClick(this.state.idsWithLevel[17])}>
                                            <div className="relative">
                                              {(!this.state.idsWithLevel[17]) ?
                                                <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                  <img
                                                    src="/logo/favicon.ico"
                                                    className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                  />
                                                </div> :
                                                <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false "
                                                  + this.getClass(this.state.idsWithLevel[17])}>
                                                  <span className="matrix-details-id text-black text-base sm:text-sm">{this.state.idsWithLevel[17]}</span>
                                                </div>
                                              }
                                            </div>
                                          </a>
                                        </div>
                                        <div className="flex flex-col justify-around items-center false">
                                          <a onClick={() => this.handleIdClick(this.state.idsWithLevel[18])}>
                                            <div className="relative">
                                              {(!this.state.idsWithLevel[18]) ?
                                                <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                  <img
                                                    src="/logo/favicon.ico"
                                                    className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                  />
                                                </div> :
                                                <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false "
                                                  + this.getClass(this.state.idsWithLevel[18])}>
                                                  <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.idsWithLevel[18]}</span>
                                                </div>
                                              }
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="flex flex-col justify-around items-center w-full">
                                  <a onClick={() => this.handleIdClick(this.state.idsWithLevel[4])}>
                                    <div className="relative">
                                      {(!this.state.idsWithLevel[4]) ?
                                        <div className="flex flex-col rounded-full bg-white-100 w-20 h-20 sm:w-10 sm:h-10 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                          <img
                                            src="/logo/favicon.ico"
                                            className="w-6 h-6 sm:h-4 sm:w-4 false"
                                          />
                                        </div> :
                                        <div className={"flex flex-col rounded-full w-20 h-20 sm:w-10 sm:h-10 items-center justify-center text-main-blue text-base group hover:opacity-75 "
                                          + this.getClass(this.state.idsWithLevel[4])}>
                                          <span className="text-black text-base sm:text-sm">{this.state.idsWithLevel[4]}</span>
                                        </div>
                                      }
                                    </div>
                                  </a>
                                  <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                    <div className="flex flex-col justify-around items-center w-full">
                                      <a onClick={() => this.handleIdClick(this.state.idsWithLevel[9])}>
                                        <div className="relative">
                                          {(!this.state.idsWithLevel[9]) ?
                                            <div className="flex flex-col rounded-full bg-white-100 w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                              <img
                                                src="/logo/favicon.ico"
                                                className="w-6 h-6 sm:h-4 sm:w-4 false"
                                              />
                                            </div> :
                                            <div className={"flex flex-col rounded-full w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75 "
                                              + this.getClass(this.state.idsWithLevel[9])}>
                                              <span className="text-black text-base sm:text-sm">{this.state.idsWithLevel[9]}</span>
                                            </div>
                                          }
                                        </div>
                                      </a>
                                      <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                        <div className="flex flex-col justify-around items-center false">
                                          <a onClick={() => this.handleIdClick(this.state.idsWithLevel[19])}>
                                            <div className="relative">
                                              {(!this.state.idsWithLevel[19]) ?
                                                <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                  <img
                                                    src="/logo/favicon.ico"
                                                    className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                  />
                                                </div> :
                                                <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false "
                                                  + this.getClass(this.state.idsWithLevel[19])}>
                                                  <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.idsWithLevel[19]}</span>
                                                </div>
                                              }
                                            </div>
                                          </a>
                                        </div>
                                        <div className="flex flex-col justify-around items-center false">
                                          <a onClick={() => this.handleIdClick(this.state.idsWithLevel[20])}>
                                            <div className="relative">
                                              {(!this.state.idsWithLevel[20]) ?
                                                <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                  <img
                                                    src="/logo/favicon.ico"
                                                    className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                  />
                                                </div> :
                                                <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false "
                                                  + this.getClass(this.state.idsWithLevel[20])}>
                                                  <span className="matrix-details-id text-black text-base sm:text-sm">{this.state.idsWithLevel[20]}</span>
                                                </div>
                                              }
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex flex-col justify-around items-center w-full">
                                      <a onClick={() => this.handleIdClick(this.state.idsWithLevel[10])}>
                                        <div className="relative">
                                          {(!this.state.idsWithLevel[10]) ?
                                            <div className="flex flex-col rounded-full bg-white-100 w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                              <img
                                                src="/logo/favicon.ico"
                                                className="w-6 h-6 sm:h-4 sm:w-4 false"
                                              />
                                            </div> :
                                            <div className={"flex flex-col rounded-full w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75 "
                                              + this.getClass(this.state.idsWithLevel[10])}>
                                              <span className="text-black text-base sm:text-sm">{this.state.idsWithLevel[10]}</span>
                                            </div>
                                          }
                                        </div>
                                      </a>
                                      <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                        <div className="flex flex-col justify-around items-center false">
                                          <a onClick={() => this.handleIdClick(this.state.idsWithLevel[21])}>
                                            <div className="relative">
                                              {(!this.state.idsWithLevel[21]) ?
                                                <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                  <img
                                                    src="/logo/favicon.ico"
                                                    className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                  />
                                                </div> :
                                                <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false "
                                                  + this.getClass(this.state.idsWithLevel[21])}>
                                                  <span className="matrix-details-id text-black text-base sm:text-sm">{this.state.idsWithLevel[21]}</span>
                                                </div>
                                              }
                                            </div>
                                          </a>
                                        </div>
                                        <div className="flex flex-col justify-around items-center false">
                                          <a onClick={() => this.handleIdClick(this.state.idsWithLevel[22])}>
                                            <div className="relative">
                                              {(!this.state.idsWithLevel[22]) ?
                                                <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                  <img
                                                    src="/logo/favicon.ico"
                                                    className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                  />
                                                </div> :
                                                <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false "
                                                  + this.getClass(this.state.idsWithLevel[22])}>
                                                  <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.idsWithLevel[22]}</span>
                                                </div>
                                              }
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="flex flex-col justify-around items-center w-full">
                              <a onClick={() => this.handleIdClick(this.state.idsWithLevel[2])}>
                                <div className="relative">
                                  {(!this.state.idsWithLevel[2]) ?
                                    <div className="flex flex-col rounded-full bg-white-100 w-20 h-20 sm:w-15 sm:h-15 items-center justify-center text-white-100 group hover:opacity-75">
                                      <img
                                        src="/logo/favicon.ico"
                                        className="w-6 h-6 sm:h-4 sm:w-4 false"
                                      />
                                    </div> :
                                    <div className={"flex flex-col rounded-full w-20 h-20 sm:w-15 sm:h-15 items-center justify-center text-white-100 group hover:opacity-75 "
                                      + this.getClass(this.state.idsWithLevel[2])}>
                                      <span className="text-black text-base sm:text-sm">{this.state.idsWithLevel[2]}</span>
                                    </div>
                                  }

                                </div>
                              </a>
                              <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                <div className="flex flex-col justify-around items-center w-full">
                                  <a onClick={() => this.handleIdClick(this.state.idsWithLevel[5])}>
                                    <div className="relative">
                                      {(!this.state.idsWithLevel[5]) ?
                                        <div className="flex flex-col rounded-full bg-white-100 w-20 h-20 sm:w-10 sm:h-10 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                          <img
                                            src="/logo/favicon.ico"
                                            className="w-6 h-6 sm:h-4 sm:w-4 false"
                                          />
                                        </div> :
                                        <div className={"flex flex-col rounded-full w-20 h-20 sm:w-10 sm:h-10 items-center justify-center text-main-blue text-base group hover:opacity-75 "
                                          + this.getClass(this.state.idsWithLevel[5])}>
                                          <span className="text-black text-base sm:text-sm">{this.state.idsWithLevel[5]}</span>
                                        </div>
                                      }
                                    </div>
                                  </a>
                                  <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                    <div className="flex flex-col justify-around items-center w-full">
                                      <a onClick={() => this.handleIdClick(this.state.idsWithLevel[11])}>
                                        <div className="relative">
                                          {(!this.state.idsWithLevel[11]) ?
                                            <div className="flex flex-col rounded-full bg-white-100 w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                              <img
                                                src="/logo/favicon.ico"
                                                className="w-6 h-6 sm:h-4 sm:w-4 false"
                                              />
                                            </div> :
                                            <div className={"flex flex-col rounded-full w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75 "
                                              + this.getClass(this.state.idsWithLevel[11])}>
                                              <span className="text-black text-base sm:text-sm">{this.state.idsWithLevel[11]}</span>
                                            </div>
                                          }
                                        </div>
                                      </a>
                                      <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                        <div className="flex flex-col justify-around items-center false">
                                          <a onClick={() => this.handleIdClick(this.state.idsWithLevel[23])}>
                                            <div className="relative">
                                              {(!this.state.idsWithLevel[23]) ?
                                                <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                  <img
                                                    src="/logo/favicon.ico"
                                                    className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                  />
                                                </div> :
                                                <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false "
                                                  + this.getClass(this.state.idsWithLevel[23])}>
                                                  <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.idsWithLevel[23]}</span>
                                                </div>
                                              }
                                            </div>
                                          </a>
                                        </div>
                                        <div className="flex flex-col justify-around items-center false">
                                          <a onClick={() => this.handleIdClick(this.state.idsWithLevel[24])}>
                                            <div className="relative">
                                              {(!this.state.idsWithLevel[24]) ?
                                                <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                  <img
                                                    src="/logo/favicon.ico"
                                                    className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                  />
                                                </div> :
                                                <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false "
                                                  + this.getClass(this.state.idsWithLevel[24])}>
                                                  <span className="matrix-details-id text-black text-base sm:text-sm">{this.state.idsWithLevel[24]}</span>
                                                </div>
                                              }
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="flex flex-col justify-around items-center w-full">
                                      <a onClick={() => this.handleIdClick(this.state.idsWithLevel[12])}>
                                        <div className="relative">
                                          {(!this.state.idsWithLevel[12]) ?
                                            <div className="flex flex-col rounded-full bg-white-100 w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                              <img
                                                src="/logo/favicon.ico"
                                                className="w-6 h-6 sm:h-4 sm:w-4 false"
                                              />
                                            </div> :
                                            <div className={"flex flex-col rounded-full w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75 "
                                              + this.getClass(this.state.idsWithLevel[12])}>
                                              <span className="text-black text-base sm:text-sm">{this.state.idsWithLevel[12]}</span>
                                            </div>
                                          }
                                        </div>
                                      </a>
                                      <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                        <div className="flex flex-col justify-around items-center false">
                                          <a onClick={() => this.handleIdClick(this.state.idsWithLevel[25])}>
                                            <div className="relative">
                                              {(!this.state.idsWithLevel[25]) ?
                                                <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                  <img
                                                    src="/logo/favicon.ico"
                                                    className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                  />
                                                </div> :
                                                <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false "
                                                  + this.getClass(this.state.idsWithLevel[25])}>
                                                  <span className="matrix-details-id text-black text-base sm:text-sm">{this.state.idsWithLevel[25]}</span>
                                                </div>
                                              }
                                            </div>
                                          </a>
                                        </div>
                                        <div className="flex flex-col justify-around items-center false">
                                          <a onClick={() => this.handleIdClick(this.state.idsWithLevel[26])}>
                                            <div className="relative">
                                              {(!this.state.idsWithLevel[26]) ?
                                                <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                  <img
                                                    src="/logo/favicon.ico"
                                                    className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                  />
                                                </div> :
                                                <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false "
                                                  + this.getClass(this.state.idsWithLevel[26])}>
                                                  <span className="matrix-details-id text-black text-base sm:text-sm">{this.state.idsWithLevel[26]}</span>
                                                </div>
                                              }
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="flex flex-col justify-around items-center w-full">
                                  <a onClick={() => this.handleIdClick(this.state.idsWithLevel[6])}>
                                    <div className="relative">
                                      {(!this.state.idsWithLevel[6]) ?
                                        <div className="flex flex-col rounded-full bg-white-100 w-20 h-20 sm:w-10 sm:h-10 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                          <img
                                            src="/logo/favicon.ico"
                                            className="w-6 h-6 sm:h-4 sm:w-4 false"
                                          />
                                        </div> :
                                        <div className={"flex flex-col rounded-full w-20 h-20 sm:w-10 sm:h-10 items-center justify-center text-main-blue text-base group hover:opacity-75 "
                                          + this.getClass(this.state.idsWithLevel[6])}>
                                          <span className="text-black text-base sm:text-sm">{this.state.idsWithLevel[6]}</span>
                                        </div>
                                      }
                                    </div>
                                  </a>
                                  <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                    <div className="flex flex-col justify-around items-center w-full">
                                      <a onClick={() => this.handleIdClick(this.state.idsWithLevel[13])}>
                                        <div className="relative">
                                          {(!this.state.idsWithLevel[13]) ?
                                            <div className="flex flex-col rounded-full bg-white-100 w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                              <img
                                                src="/logo/favicon.ico"
                                                className="w-6 h-6 sm:h-4 sm:w-4 false"
                                              />
                                            </div> :
                                            <div className={"flex flex-col rounded-full w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75 "
                                              + this.getClass(this.state.idsWithLevel[13])}>
                                              <span className="text-black text-base sm:text-sm">{this.state.idsWithLevel[13]}</span>
                                            </div>
                                          }
                                        </div>
                                      </a>
                                      <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                        <div className="flex flex-col justify-around items-center false">
                                          <a onClick={() => this.handleIdClick(this.state.idsWithLevel[27])}>
                                            <div className="relative">
                                              {(!this.state.idsWithLevel[27]) ?
                                                <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                  <img
                                                    src="/logo/favicon.ico"
                                                    className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                  />
                                                </div> :
                                                <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false "
                                                  + this.getClass(this.state.idsWithLevel[27])}>
                                                  <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.idsWithLevel[27]}</span>
                                                </div>
                                              }
                                            </div>
                                          </a>
                                        </div>
                                        <a href="#"></a>
                                        <div className="flex flex-col justify-around items-center false">
                                          <a href="#"></a>
                                          <a onClick={() => this.handleIdClick(this.state.idsWithLevel[28])}>
                                            <div className="relative">
                                              {(!this.state.idsWithLevel[28]) ?
                                                <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                  <img
                                                    src="/logo/favicon.ico"
                                                    className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                  />
                                                </div> :
                                                <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false "
                                                  + this.getClass(this.state.idsWithLevel[28])}>
                                                  <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.idsWithLevel[28]}</span>
                                                </div>
                                              }
                                            </div>
                                          </a>
                                        </div>
                                        <a href="#"></a>
                                      </div>
                                      <a href="#"></a>
                                    </div>
                                    <a href="#"></a>
                                    <div className="flex flex-col justify-around items-center w-full">
                                      <a href="#"></a>
                                      <a onClick={() => this.handleIdClick(this.state.idsWithLevel[14])}>
                                        <div className="relative">
                                          {(!this.state.idsWithLevel[14]) ?
                                            <div className="flex flex-col rounded-full bg-white-100 w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75">
                                              <img
                                                src="/logo/favicon.ico"
                                                className="w-6 h-6 sm:h-4 sm:w-4 false"
                                              />
                                            </div> :
                                            <div className={"flex flex-col rounded-full w-13 h-13 sm:w-6.5 sm:h-6.5 items-center justify-center text-main-blue text-base group hover:opacity-75 "
                                              + this.getClass(this.state.idsWithLevel[14])}>
                                              <span className="text-black text-base sm:text-sm">{this.state.idsWithLevel[14]}</span>
                                            </div>
                                          }
                                        </div>
                                      </a>
                                      <div className="flex w-full items-start justify-evenly mt-7.5 sm:mt-5 first:mt-0">
                                        <div className="flex flex-col justify-around items-center false">
                                          <a onClick={() => this.handleIdClick(this.state.idsWithLevel[29])}>
                                            <div className="relative">
                                              {(!this.state.idsWithLevel[29]) ?
                                                <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                  <img
                                                    src="/logo/favicon.ico"
                                                    className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                  />
                                                </div> :
                                                <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false "
                                                  + this.getClass(this.state.idsWithLevel[29])}>
                                                  <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.idsWithLevel[29]}</span>
                                                </div>
                                              }
                                            </div>
                                          </a>
                                        </div>
                                        <a href="#"></a>
                                        <div className="flex flex-col justify-around items-center false">
                                          <a href="#"></a>
                                          <a onClick={() => this.handleIdClick(this.state.idsWithLevel[30])}>
                                            <div className="relative">
                                              {(!this.state.idsWithLevel[30]) ?
                                                <div className="flex flex-col rounded-full bg-white-100 w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false">
                                                  <img
                                                    src="/logo/favicon.ico"
                                                    className="w-3.5 h-3.5 sm:h-2 sm:w-2 false"
                                                  />
                                                </div> :
                                                <div className={"flex flex-col rounded-full w-6.5 h-6.5 sm:w-3 sm:h-3 items-center justify-center text-main-blue text-base group false "
                                                  + this.getClass(this.state.idsWithLevel[30])}>
                                                  <span className="text-black text-base sm:text-sm matrix-details-id">{this.state.idsWithLevel[30]}</span>
                                                </div>
                                              }
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex absolute rounded -bottom-5 top-5 right-5 left-2.5 bg-opacity-50"></div>
                  </div>
                  {(this.state.level < 3) && (
                    <button 
                      className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-2.5 bg-black-light hover:bg-line-gray active:bg-active-gray min-w-140px xl:hidden p-7 bg-black-light rounded">
                      <a
                        className="flex items-center justify-center font-normal h-full w-full"
                        href={`/dashboard/${this.state.userId}/${(this.state.level <= 3) ? (+this.state.level + 1) : 1}`}
                      >
                        <span className="text-white text-base mr-2.5">
                          Round {(this.state.level <= 3) ? (+this.state.level + 1) : 1}
                        </span>
                        <svg
                          className="flex-shrink-0"
                          width="8"
                          height="14"
                          stroke="#fff"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="m1 13 6-6M1 1l6 6"
                            strokeWidth={1.5}
                            strokeLinecap={"round"}
                            strokeLinejoin={"round"}
                          ></path>
                        </svg>
                      </a>
                    </button>
                  )}
                </div>

                <div className="hidden xl:flex justify-between">
                  {(this.state.level > 1) && (
                    <button className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-2.5 bg-black-light hover:bg-line-gray active:bg-active-gray min-w-140px xl:hidden p-7 bg-black-light rounded">
                      <a
                        className="flex items-center justify-center font-normal h-full w-full"
                        href={`/dashboard/${this.state.userId}/${+this.state.level - 1}`}
                      >
                        <span className="text-white text-base mr-2.5">
                          Level {this.state.level - 1}
                        </span>

                      </a>
                    </button>
                  )}
                  {(this.state.level < 3) && (
                    <button className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-2.5 bg-black-light hover:bg-line-gray active:bg-active-gray min-w-140px xl:hidden p-7 bg-black-light rounded">
                      <a
                        className="flex items-center justify-center font-normal h-full w-full"
                        href={`/dashboard/${this.state.userId}/${(this.state.level <= 3) ? (+this.state.level + 1) : 1}`}
                      >
                        <span className="text-white text-base mr-2.5">
                          Level {(this.state.level <= 3) ? (+this.state.level + 1) : 1}
                        </span>
                        <svg
                          className="flex-shrink-0"
                          width="8"
                          height="14"
                          stroke="#fff"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="m1 13 6-6M1 1l6 6"
                            strokeWidth={1.5}
                            strokeLinecap={"round"}
                            strokeLinejoin={"round"}
                          ></path>
                        </svg>
                      </a>
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="flex w-full items-center justify-center z-10 sm:px-5">
              <div style={{ backgroundColor: "#000000", backgroundImage: "linear-gradient(147deg, #000000 0%, #2c3e50 74%)", borderRadius: "0 3rem 3rem 3rem" }}
                className="flex bg-black-light p-5 rounded w-full items-center justify-center  xl:w-full">
                <div className="flex w-full items-center justify-center z-10 sm:px-5">
                  <div style={{ backgroundColor: "#000000", backgroundImage: "linear-gradient(147deg, #000000 0%, #2c3e50 74%)", borderRadius: "0 3rem 3rem 3rem" }}
                    className="flex bg-black-light p-5 rounded w-full items-center justify-center xl:w-full">
                    <div className="flex items-center justify-between w-full gap-4">

                      {/* Previous Cycle - Static Area */}
                      <div className="flex-1 text-center">
                        {(this.state.previewCycle > 0) ? (
                          <a
                            className="dropdown-toggle text-white text-base sm:text-sm flex items-center justify-center cursor-pointer"
                            onClick={() => this.handleReinvestClick(this.state.userId, +this.state.previewCycle - 1)}
                          >
                            <span className="mr-2">Prev Class : {+this.state.previewCycle}</span>
                          </a>
                        ) : (
                          <span className="text-white/50 text-base sm:text-sm">Prev Class : --</span>
                        )}
                      </div>

                      {/* Current Cycle - Static Area */}
                      <div className="flex-1 text-center">
                        <a
                          className="dropdown-toggle text-white text-base sm:text-sm flex items-center justify-center cursor-pointer"
                          onClick={() => this.handleReinvestClick(this.state.userId, this.state.previewCycle)}
                        >
                          <span className="mr-2">Current Class : {this.state.previewCycle + 1}</span>
                        </a>
                      </div>

                      {/* Next Cycle - Static Area */}
                      <div className="flex-1 text-center">
                        {(this.state.previewCycle < this.state.reinvestNo) ? (
                          <a
                            className="dropdown-toggle text-white text-base sm:text-sm flex items-center justify-center cursor-pointer"
                            onClick={() => this.handleReinvestClick(this.state.userId, +this.state.previewCycle + 1)}
                          >
                            <span className="mr-2">Next Class : {+this.state.previewCycle + 2}</span>
                          </a>
                        ) : (
                          <span className="text-white/50 text-base sm:text-sm">Next Class : --</span>
                        )}
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="flex w-full items-center justify-center z-10 sm:px-5 mt-4">
              <button 
                onClick={() => this.handleGlobalRewardsClick()} 
                className="flex justify-center items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none px-5 py-2.5 bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 active:from-purple-800 active:to-blue-800 shadow-lg hover:shadow-xl transition-all duration-200 w-full xl:w-full"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Global Rewards</span>
              </button>
            </div> */}
            <div className="!mt-15 sm:!mt-7.5 sm:px-5">
              <div className="flex items-center flex-wrap">
                <div className="flex items-center text-white-500 mb-5 mr-7.5 sm:items-start sm:mb-2.5 sm:pr-2.5 sm:mr-0 sm:w-1/2 sm:order-2">
                  <div className="w-5 h-5 flex-shrink-0 mr-2.5 bg-white"></div>
                  <span className="text-base sm:text-sm">Direct partner</span>
                </div>
                <div className="flex items-center text-white-500 mb-5 mr-7.5 sm:items-start sm:mb-2.5 sm:pr-2.5 sm:mr-0 sm:w-1/2 sm:order-4">
                  <div className="w-5 h-5 flex-shrink-0 mr-2.5 bg-light-blue"></div>
                  <span className="text-base sm:text-sm">
                    Spillover from above
                  </span>
                </div>
                <div className="flex items-center text-white-500 mb-5 mr-7.5 sm:items-start sm:mb-2.5 sm:pr-2.5 sm:mr-0 sm:w-1/2 sm:order-6">
                  <div className="w-5 h-5 flex-shrink-0 mr-2.5 bg-yellow"></div>
                  <span className="text-base sm:text-sm">
                    Spillover from below
                  </span>
                </div>
                <div className="flex items-center text-white-500 mb-5 mr-7.5 sm:items-start sm:mb-2.5 sm:pr-2.5 sm:mr-0 sm:w-1/2 sm:order-7">
                  <div className="w-5 h-5 flex-shrink-0 mr-2.5 bg-green-500"></div>
                  <span className="text-base sm:text-sm">OverTake</span>
                </div>
                {/* <div className="flex items-center text-white-500 mb-5 mr-7.5 sm:items-start sm:mb-2.5 sm:pr-2.5 sm:mr-0 sm:w-1/2 sm:order-1">
                  <svg
                    className="w-5 h-5 mr-2.5 stroke-current text-white"
                    viewBox="0 0 16 16"
                    fill="none"
                    stroke="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 7.333A2.667 2.667 0 1 0 6 2a2.667 2.667 0 0 0 0 5.333ZM2 14v-1.333A2.667 2.667 0 0 1 4.667 10h2.666A2.667 2.667 0 0 1 10 12.667V14M10.667 2.086a2.667 2.667 0 0 1 0 5.167M14 14v-1.333a2.667 2.667 0 0 0-2-2.567"
                      strokeWidth={1.333}
                      strokeLinecap={"round"}
                      strokeLinejoin={"round"}
                    ></path>
                  </svg>
                  <span className="text-base sm:text-sm">Partners on Slot</span>
                </div> */}
                <div className="flex   items-center text-white-500 mb-5 mr-7.5 sm:items-start sm:mb-2.5 sm:pr-2.5 sm:mr-0 sm:w-1/2 sm:order-3">
                  <svg
                    className="w-5 h-5 mr-2.5 stroke-current text-white"
                    viewBox="0 0 20 20"
                    fill="none"
                    stroke="#2CFF4E"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      clipRule="evenodd"
                      d="M6.354 3.818a7.25 7.25 0 0 1 10.808 5.28.5.5 0 1 1-.99.137A6.25 6.25 0 0 0 4.551 7h2.115a.5.5 0 0 1 0 1H3.333a.5.5 0 0 1-.5-.5V4.167a.5.5 0 1 1 1 0v2.086a7.25 7.25 0 0 1 2.521-2.435ZM3.265 10.338a.5.5 0 0 1 .564.427A6.25 6.25 0 0 0 15.449 13h-2.116a.5.5 0 1 1 0-1H16.667a.5.5 0 0 1 .5.5v3.333a.5.5 0 1 1-1 0v-2.086a7.25 7.25 0 0 1-13.329-2.845.5.5 0 0 1 .427-.564Z"
                    ></path>
                  </svg>
                  <span className="text-base sm:text-sm">ReCycle</span>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    );
  }
}

export default withWrapper(Matrix);
